// import React from "react";

// const gallery = [
//   { id: 7, name: "Swift Dzire", image: "images/fleet/dsire.jpg", category: "cat-1" },
//   { id: 5, name: "Hyundai Aura", image: "images/fleet/aura.jpg", category: "cat-5" },
//   { id: 8, name: "Ertiga", image: "images/fleet/ertiga.jpg", category: "cat-2" },
//   { id: 1, name: "Kia Carens", image: "images/fleet/kia.jpg", category: "cat-1" },
//   { id: 10, name: "Innova Crysta", image: "images/fleet/innova-crysta.jpg", category: "cat-4" },
//   { id: 2, name: "Mini Bus", image: "images/fleet/mini-bus.jpg", category: "cat-2" },
//   { id: 3, name: "Tempo Traveller", image: "images/fleet/tempo-traveller.jpg", category: "cat-3" },
//   { id: 4, name: "Urbania", image: "images/fleet/urbania.jpg", category: "cat-4" },
//   { id: 6, name: "Bus", image: "images/fleet/bus.jpg", category: "cat-6" },
//   { id: 9, name: "Fortuner", image: "images/fleet/fortuner.jpg", category: "cat-3" },
// ];
// const Gallery = () => {
//   return (

// <>


//   <div className="breadcrumb-bar">
//         <div className="container">
//           <div className="row align-items-center text-center">
//             <div className="col-md-12 col-12">
//               <h2 className="breadcrumb-title">Gallery</h2>
//             </div>
//           </div>
//         </div>
//       </div>

//     <div className="section-full site-bg-white p-t150 p-b120 twm-portfolio-wrap">
//       <div className="container">

       

//         {/* Gallery */}
//         <ul className="masonry-outer work-grid row clearfix list-unstyled m-b0">

//           {gallery.map((item) => (
//             <li
//               key={item.id}
//               className={`masonry-item ${item.category} col-lg-4 col-md-6 m-b30`}
//             >
//               <div className="twm-gallery-section">

//                 <div className="elem media">
//                   <img src={item.image} alt={item.name} />
//                   <span className="icon-view">
//                     <i className="feather feather-maximize"></i>
//                   </span>
//                 </div>

//                 <div className="twm-gallery-info">
//                   <h3 className="twm-title">{item.name}</h3>
//                 </div>

//               </div>
//             </li>
//           ))}

//         </ul>

//       </div>
//     </div>

// </>
//   );
// };

// export default Gallery;



import React, { useState } from "react";

const gallery = [
   { id: 5, name: "", image: "images/fleet/1.jpeg" },
  { id: 5, name: "", image: "images/fleet/2.jpeg" },
  { id: 5, name: "", image: "images/fleet/3.jpeg" },
  { id: 5, name: "", image: "images/fleet/4.jpeg" },
  { id: 7, name: "Swift Dzire", image: "images/fleet/dsire.jpg" },

  { id: 5, name: "", image: "images/fleet/5.jpeg" },
  { id: 5, name: "Hyundai Aura", image: "images/fleet/aura.jpg" },
 
  { id: 8, name: "Ertiga", image: "images/fleet/ertiga.jpg" },
  { id: 1, name: "Kia Carens", image: "images/fleet/kia.jpg" },
  { id: 10, name: "Innova Crysta", image: "images/fleet/innova-crysta.jpg" },
  { id: 2, name: "Mini Bus", image: "images/fleet/mini-bus.jpg" },
  { id: 3, name: "Tempo Traveller", image: "images/fleet/tempo-traveller.jpg" },
  { id: 4, name: "Urbania", image: "images/fleet/urbania.jpg" },
  { id: 6, name: "Bus", image: "images/fleet/bus.jpg" },
  { id: 9, name: "Fortuner", image: "images/fleet/fortuner.jpg" },
];

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(null);

  const openImage = (index) => {
    setCurrentIndex(index);
  };

  const closeImage = () => {
    setCurrentIndex(null);
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === gallery.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? gallery.length - 1 : prev - 1
    );
  };

  return (
    <>
      <div className="breadcrumb-bar text-center">
        <h2>Gallery</h2>
      </div>

      <div className="container py-5">
        <div className="row">
          {gallery.map((item, index) => (
            <div key={item.id} className="col-lg-4 col-md-6 mb-4">
              <div className="gallery-card borderr" onClick={() => openImage(index)}>
                <img src={item.image} alt={item.name} />
                <h5>{item.name}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* LIGHTBOX */}
      {currentIndex !== null && (
        <div className="lightbox">
          <span className="close darkcolorrrr" onClick={closeImage}>✖</span>

          <span className="prev" onClick={prevImage}>❮</span>
          <img
            src={gallery[currentIndex].image}
            alt="preview"
            className="lightbox-img "
          />
          <span className="next" onClick={nextImage}>❯</span>
        </div>
      )}
    </>
  );
};

export default Gallery;